import Vue from 'vue';
import Vuex from 'vuex';
import { commonServer } from '@/API/home';

// 报备申请模块
import newApplication from './modules/newApplication';
// 路由菜单模块
import routerMenu from './modules/routerMenu';
// user模块影响较大，暂不修改
// import userInfo from './modules/userInfo';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    routerMenu,
    newApplication
  },
  state: {
    subPageLoading: false,
    userInfo: {},
    currentActivityData: {},
    breadcrumbList: [],
    keepAliveList: [
      'ActivityQuery',
      'BudgetPerformance',
      'WaitingProcessing',
      'CompletedProcessing',
      'ClueSuspend',
      'CluePoolList',
      'PendingApproval',
      'AlreadyApproved',
      'AnnualMarketingPlan'
    ],
    goodsAddress: {},
    qdSignContractFileId: '',
    qdSignContractFormInfo: {},
    pendingApprovalNum: null,
    useSimplifiedUI: false,
    useSimplifiedForm: false
  },
  mutations: {
    setPendingApprovalNum (state, data) {
      state.pendingApprovalNum = data;
    },
    setGoodsAddress (state, data) {
      state.goodsAddress = data;
    },
    setQdSignContractFormInfo (state, data) {
      state.qdSignContractFormInfo = data;
    },
    setQdSignContractFileId (state, data) {
      state.qdSignContractFileId = data;
    },
    setBreadcrumbList (state, data) {
      if (data && data[0] && data[0].path === '/home') {
        state.breadcrumbList = [];
        return;
      }
      if (state.breadcrumbList && state.breadcrumbList.length > 0) {
        let beforeObj = state.breadcrumbList[state.breadcrumbList.length - 1];
        let afterObj = data[data.length - 1];
        // 防止刷新当前页面时，往后追加相同的标签
        if (beforeObj.path === afterObj.path && beforeObj.name === afterObj.name && beforeObj.i18nName === afterObj.i18nName) return;
        // 防止国际化操作导致的追加相同标签
        if (beforeObj.path === afterObj.path && beforeObj.name !== afterObj.name && beforeObj.i18nName === afterObj.i18nName) {
          state.breadcrumbList = data.splice(0, data.length - 1);
          return;
        };
      }
      state.breadcrumbList = data;
    },
    setKeepAliveList (state, data) {
      state.keepAliveList = data;
    },
    setSubPageLoading (state, data) {
      state.subPageLoading = data;
    },
    setUserInfo (state, data) {
      state.userInfo = data;
      state.useSimplifiedUI = (data && data.useSimplifiedUI) || false;
      try {
        window.webfunny.wmInitUser(data.sysUser.userId, 'tag', '1.0.1');
      } catch (e) {
        console.log(e);
      }
    },
    setActivityData (state, data) {
      state.currentActivityData = data;
    },
    setUseSimplifiedForm (state, data) {
      state.useSimplifiedForm = data;
    }
  },
  actions: {
    getPendingApprovalNum ({ commit }) {
      commonServer.getPendingQuantity().then(res => {
        if (res.status === '200') {
          commit('setPendingApprovalNum', res.data);
        }
      });
    },
    getUserInfo ({ commit }) {
      commonServer.getUserInfo().then((res) => {
        if (res.status === '200') {
          commit('setUserInfo', res.data);
        }
      });
    }
  }
});
